import type { SVGProps } from "react";
export interface PlaneArrivalIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PlaneArrivalIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PlaneArrivalIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m22 19.875.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H2a1.125 1.125 0 0 1 0-2.25zM10.025 1.891l.205.041 1.184.317.183.055a3.13 3.13 0 0 1 1.95 1.91l2.11 5.9 2.813.755c1.03.276 2.237.733 3.154 1.41.907.67 1.81 1.797 1.406 3.306-.404 1.508-1.75 2.032-2.87 2.159-1.133.128-2.407-.079-3.436-.355L6.486 14.647a5.1 5.1 0 0 1-1.774-.87l-.22-.179-2.872-2.443a2.13 2.13 0 0 1-.734-1.387l-.013-.232V5.238l.013-.212a1.627 1.627 0 0 1 2.017-1.362l.201.066.977.392.3.14a3.12 3.12 0 0 1 1.47 1.684l.625 1.71 2.202.59-.484-4.574a1.625 1.625 0 0 1 1.831-1.78Zm.986 7.023.009.21a1.625 1.625 0 0 1-2.045 1.53l-3.393-.908a1.63 1.63 0 0 1-1.026-.83l-.08-.181-.738-2.014a.88.88 0 0 0-.332-.425l-.163-.085-.12-.048v3.315l2.826 2.406.255.194c.264.178.556.312.865.395l10.237 2.742c.902.242 1.866.376 2.601.293.749-.084.902-.324.95-.505.05-.181.036-.465-.569-.912-.595-.44-1.497-.806-2.4-1.048l-3.127-.838a1.63 1.63 0 0 1-1.031-.84l-.08-.182-2.221-6.21a.88.88 0 0 0-.598-.55l-.303-.083z"
      />
    </svg>
  );
}
